import { createSlice } from "@reduxjs/toolkit";

const userSlice=createSlice(
{name:"user",
initialState:{name:"",email:"",photo:""},
reducers:{
    setUserLog:(state,action)=>{
        state.name=action.payload.name;
        state.email=action.payload.email;
        state.photo=action.payload.photo;
    },
    setUserOut:(state)=>{

        state.name="";
        state.email="";
        state.photo="";
    }
}});

export const {setUserLog,setUserOut} =userSlice.actions;

export const getname=(state)=>state.user.name;
export const getemail=(state)=>state.user.email;
export const getphoto=(state)=>state.user.photo;
export default userSlice.reducer;